import { api } from './api';

export interface MapRestaurant {
  id: number;
  name: string;
  city: string | null;
  country: string | null;
  address: string;
  latitude: number | null;
  longitude: number | null;
  location_source: string;
  michelin_stars: number;
  guide_year: number;
}

export const fetchRestaurantMap = async (): Promise<MapRestaurant[]> =>
  (await api.get('/restaurant-map/')).data;

export const hasCoordinates = (venue: MapRestaurant): boolean =>
  venue.latitude !== null && venue.longitude !== null &&
  Number.isFinite(venue.latitude) && Number.isFinite(venue.longitude);

/** Great-circle distance, not walking or driving distance. Calculated on device. */
export function distanceKm(lat: number, lng: number, origin: [number, number]): number {
  const radians = (n: number) => n * Math.PI / 180;
  const a = Math.sin(radians(lat - origin[0]) / 2) ** 2 +
    Math.cos(radians(origin[0])) * Math.cos(radians(lat)) *
    Math.sin(radians(lng - origin[1]) / 2) ** 2;
  return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(Math.max(0, 1 - a)));
}

export interface MapLocation { label: string; latitude: number; longitude: number; }
export const searchMapLocations = async (query: string): Promise<MapLocation[]> =>
  (await api.post('/location-search/', { query })).data.results;
